export default function CommunitySection() {
  const initiatives = [
    {
      title: '地域イベントへの参加',
      description: '地域の健康イベントや介護相談会に積極的に参加し、地域の皆様との交流を大切にしています。介護に関する不安や疑問にお答えし、地域全体で支え合う環境づくりに貢献しています。',
      image: 'https://public.readdy.ai/ai/img_res/2fd8530d84c21c441f429994760d357f.jpg'
    },
    {
      title: '地域ケアマネージャーとの連携',
      description: '地域のケアマネージャーの皆様と密に連携し、ご利用者様に最適なケアプランを実現しています。定期的な情報交換会を開催し、地域全体のケアの質向上に努めています。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20meeting%20of%20Japanese%20healthcare%20workers%20and%20care%20managers%20collaborating%20around%20a%20table%20in%20a%20bright%20modern%20office.%20They%20are%20reviewing%20documents%20and%20having%20a%20productive%20discussion.%20Clean%20simple%20background%20with%20natural%20lighting%20emphasizing%20teamwork%20and%20professional%20cooperation.%20Business%20photography%20style&width=800&height=600&seq=community002&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
          地域密着への取り組み
        </h2>

        <div className="space-y-24 max-w-6xl mx-auto">
          {initiatives.map((initiative, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="h-[400px] rounded-3xl overflow-hidden shadow-lg">
                  <img
                    src={initiative.image}
                    alt={initiative.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  {initiative.title}
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  {initiative.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
